import { render, staticRenderFns } from "./Protected.vue?vue&type=template&id=04622208&scoped=true"
import script from "./Protected.vue?vue&type=script&lang=js"
export * from "./Protected.vue?vue&type=script&lang=js"
import style0 from "./Protected.vue?vue&type=style&index=0&id=04622208&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04622208",
  null
  
)

export default component.exports